"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAnalyticsMetadataKeys = exports.GoogleAnalyticsEventTypes = exports.GoogleAnalyticsActions = void 0;
var GoogleAnalyticsActions;
(function (GoogleAnalyticsActions) {
    GoogleAnalyticsActions["ApplicationSubmitted"] = "APPLICATION_SUBMITTED";
    GoogleAnalyticsActions["DepositsCalculatorChanged"] = "CALCULATOR_INPUT_CHANGED";
    GoogleAnalyticsActions["DepositsCalculatorLoadedResults"] = "CALCULATOR_LOADED_RESULTS";
    GoogleAnalyticsActions["DepositsCalculatorOfferClicked"] = "CALCULATOR_OFFER_CLICKED";
    GoogleAnalyticsActions["DepositsCalculatorSliderChanged"] = "CALCULATOR_SLIDER_CHANGED";
    GoogleAnalyticsActions["Filtered"] = "FILTERED";
    GoogleAnalyticsActions["LoadedResults"] = "LOADED_RESULTS";
    GoogleAnalyticsActions["PersonalizedLoadedResults"] = "PERSONALIZED_LOADED_RESULTS";
    GoogleAnalyticsActions["PreviewLoadedResults"] = "PREVIEW_LOADED_RESULTS";
    GoogleAnalyticsActions["PreviewOfferClicked"] = "PREVIEW_OFFER_CLICKED";
    GoogleAnalyticsActions["ProductClicked"] = "PRODUCT_CLICKED";
    GoogleAnalyticsActions["RatesFilterChanged"] = "RATES_FILTER_CHANGED";
    GoogleAnalyticsActions["RateTableContainsPreApprovedOffers"] = "RATE_TABLE_CONTAINS_PREAPPROVED_OFFERS";
    GoogleAnalyticsActions["RateTableContainsPreQualifiedOffers"] = "RATE_TABLE_CONTAINS_PREQUALIFIED_OFFERS";
    GoogleAnalyticsActions["RateTableContainsPreSelectedOffers"] = "RATE_TABLE_CONTAINS_PRESELECTED_OFFERS";
    GoogleAnalyticsActions["ResultsOfferClicked"] = "RESULTS_OFFER_CLICKED";
    GoogleAnalyticsActions["SeeMoreFromLender"] = "SEE_MORE_BY_LENDER";
    GoogleAnalyticsActions["SortChanged"] = "SORT_CHANGED";
    GoogleAnalyticsActions["ToggledCoapplicant"] = "TOGGLED_COAPPLICANT";
    GoogleAnalyticsActions["ToggledCoapplicantAddress"] = "TOGGLED_COAPPLICANT_ADDRESS";
    GoogleAnalyticsActions["ValidationError"] = "VALIDATION_ERROR";
    GoogleAnalyticsActions["PlaidLinkInit"] = "PLAID_LINK_INIT";
    GoogleAnalyticsActions["PlaidLinkResult"] = "PLAID_LINK_RESULT";
    GoogleAnalyticsActions["PlaidPrefillSubmitted"] = "PLAID_PREFILL_SUBMITTED";
})(GoogleAnalyticsActions = exports.GoogleAnalyticsActions || (exports.GoogleAnalyticsActions = {}));
var GoogleAnalyticsEventTypes;
(function (GoogleAnalyticsEventTypes) {
    GoogleAnalyticsEventTypes["Event"] = "ga_event";
    GoogleAnalyticsEventTypes["Pageview"] = "ga_pageview";
})(GoogleAnalyticsEventTypes = exports.GoogleAnalyticsEventTypes || (exports.GoogleAnalyticsEventTypes = {}));
var GoogleAnalyticsMetadataKeys;
(function (GoogleAnalyticsMetadataKeys) {
    GoogleAnalyticsMetadataKeys["CompanyUuid"] = "dimension1";
    GoogleAnalyticsMetadataKeys["TrackingUuid"] = "dimension2";
    GoogleAnalyticsMetadataKeys["Type"] = "dimension3";
    GoogleAnalyticsMetadataKeys["Step"] = "dimension4";
    GoogleAnalyticsMetadataKeys["PartnerKey"] = "dimension5";
    GoogleAnalyticsMetadataKeys["ConsumerBrand"] = "dimension6";
    GoogleAnalyticsMetadataKeys["Flow"] = "dimension7";
})(GoogleAnalyticsMetadataKeys = exports.GoogleAnalyticsMetadataKeys || (exports.GoogleAnalyticsMetadataKeys = {}));
//# sourceMappingURL=google-analytics.js.map